import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useOverlayState } from '../../../hooks/useOverlayState';

import EyeIcon from '../../../design-system/Icons/EyeIcon';
import EyeOffIcon from '../../../design-system/Icons/EyeOffIcon';
import HighlightedIcon from '../../../design-system/HighlightedIcon/HighlightedIcon';
import PlayProcessIcon from '../../../design-system/Icons/PlayProcessIcon';
import TimestampDisplay from '../../../design-system/TimestampDisplay/TimestampDisplay';
import TruncatingLabelList from '../../PlaybookTemplatesIndexPage/TruncatingLabelList/TruncatingLabelList';
import PlaybookTemplateMoreOptionsPopup from '../PlaybookTemplateMoreOptionsPopup/PlaybookTemplateMoreOptionsPopup';
import { ButtonIcon } from '../../../design-system';
import { More2FillIcon } from '../../../design-system/Icons';

const PlaybookTemplateCard = ({ item, requestKeysToMutate }) => {
    const { id, name, description, labels, updated_at, is_live } = item;

    const location = useLocation();

    const { isOpened: isPopupOpened, open: openPopup, close: closePopup } = useOverlayState();

    return (
        <Link
            to={`/templates/playbook/${id}`}
            state={{ from: location }}
            className="w-full h-full relative rounded-2 bg-white border-1 border-neutral-100 p-5 flex flex-col gap-4 justify-between self-stretch cursor-pointer"
        >
            <div className="absolute top-1.5 right-1">
                <ButtonIcon type="link" size="xs" icon={More2FillIcon} onClick={openPopup} />
                {isPopupOpened && (
                    <PlaybookTemplateMoreOptionsPopup
                        id={id}
                        is_live={is_live}
                        requestKeysToMutate={requestKeysToMutate}
                        onClose={closePopup}
                    />
                )}
            </div>

            <div>
                <div className="flex items-center gap-2 mb-2 w-[calc(100%-6px)]">
                    <HighlightedIcon icon={PlayProcessIcon} variant="neutral" />

                    <p className="font-body-bold text-body-bold-s text-black line-clamp-2">
                        {name}
                    </p>
                </div>
                <p className="font-body text-body-regular-xs text-neutral-300 line-clamp-2">
                    {description}
                </p>
            </div>

            <div className="flex flex-col gap-4">
                <TruncatingLabelList labels={labels} showRemainingCount />

                <div className="flex items-center justify-between gap-1">
                    <TimestampDisplay
                        label="Last Updated"
                        timestamp={updated_at}
                        dateTimeFormat="MM/dd/yyyy"
                        customLabelStyles="text-neutral-500"
                        withClockIcon
                    />

                    <div>
                        {is_live ? (
                            <EyeIcon width={14} height={14} color="#754DCF" />
                        ) : (
                            <EyeOffIcon width={14} height={14} color="#CFD6E5" />
                        )}
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default PlaybookTemplateCard;
